export default __webpack_public_path__ + "static/media/ocshomelogocolor.e731c064.png";